<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      isActive: 0,
      operateState: 0, // 0新增 1编辑
      addInfo: {}, // 新增数据
      examInfo: {},
      examRow: {}, // 当前操作培训
      isread: "",
      PaperMode: "", // 试卷类型状态
      deleteArr: [], // 假删的ID数组
      list_vip: [], // 考生的数组
      type: 0, // 0任务管理进入 1培训情况进入
      passScore:0,
    };
  },
  components: {
    Page: () => import("./components/page.vue"),
    AddPage: () => import("./components/addPage.vue"), // 添加培训
    ArrangeCandidate: () => import("./components/arrangeCandidate.vue"), // 添加考生
    arrangeTask: () => import("./components/arrangeTask.vue"), // 创建任务第一步
    arrangeTaskTwo: () => import("./components/arrangeTaskTwo.vue"), // 创建任务第二步
    confirmInfo: () => import("./components/confirmInfo.vue"), // 最后一步
    Details: () => import("../situation/components/details.vue"), // 培训详情
    myDetails: () => import("../situation/components/myDetails.vue"), // 培训详情
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Page";
        case 1:
          return "AddPage";
        case 2:
          return "ArrangeCandidate";
        case 3:
          return "arrangeTask";
        case 4:
          return "arrangeTaskTwo";
        case 5:
          return "confirmInfo";
        case 6:
          return "Details";
        case 7:
          return "myDetails";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
};
</script>
  